const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M83.878,117.475c0,0-94.612,107.722-76.771,141.63c17.84,33.908,99.987-7.078,93.955,8.449 C95.03,283.081,4.616,377.803,37.565,420.211c32.949,42.407,175.223-45.544,164.949-7.435 c-10.273,38.109-8.719,84.131,51.83,76.16c60.549-7.971,124.865-133.606,120.633-108.308 c-4.232,25.298-17.372,115.468,41.703,90.506c59.075-24.962,88.697-140.185,75.707-219.996 c-12.99-79.812-50.12-39.098-64.815-41.949c-14.694-2.851,38.58-112.258,9.915-140.246 c-28.665-27.988-165.614,74.227-180.761,79.718c-15.147,5.49,36.518-90.436-11.026-95.165 C198.157,48.767,147.45,58.494,83.878,117.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M83.878,117.475c0,0-94.612,107.722-76.771,141.63 c17.84,33.908,99.987-7.078,93.955,8.449C95.03,283.081,4.616,377.803,37.565,420.211c32.949,42.407,175.223-45.544,164.949-7.435 c-10.273,38.109-8.719,84.131,51.83,76.16c60.549-7.971,124.865-133.606,120.633-108.308 c-4.232,25.298-17.372,115.468,41.703,90.506c59.075-24.962,88.697-140.185,75.707-219.996 c-12.99-79.812-50.12-39.098-64.815-41.949c-14.694-2.851,38.58-112.258,9.915-140.246 c-28.665-27.988-165.614,74.227-180.761,79.718c-15.147,5.49,36.518-90.436-11.026-95.165 C198.157,48.767,147.45,58.494,83.878,117.475z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 445.075,
    cy: 331.277,
    rx: 7.512,
    ry: 19.703
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M421.735,319.126c2.348,7.391,6.86,12.554,10.076,11.532 c3.217-1.022,3.921-7.842,1.573-15.233c-2.348-7.391-6.86-12.554-10.076-11.532C420.091,304.915,419.387,311.735,421.735,319.126 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M476.854,363.693c7.646-1.295,13.388-5.043,12.824-8.371 c-0.564-3.328-7.219-4.975-14.865-3.68c-7.646,1.295-13.388,5.043-12.824,8.371C462.552,363.341,469.208,364.988,476.854,363.693 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M414.663,345.478c6.387,6.334,13.932,9.08,16.853,6.134 c2.921-2.946,0.112-10.468-6.274-16.802c-6.386-6.334-13.932-9.08-16.853-6.134C405.468,331.621,408.277,339.144,414.663,345.478 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M458.669,328.105c-6.175,8.96-8.016,18.405-4.11,21.097 c3.905,2.692,12.078-2.389,18.253-11.349c6.175-8.96,8.016-18.406,4.11-21.097C473.017,314.064,464.845,319.145,458.669,328.105z "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 444.548,
    y1: 349.997,
    x2: 443.967,
    y2: 409.937
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 445.249,
    y1: 323.951,
    x2: 444.548,
    y2: 349.997
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 445.198,
    y1: 319.701,
    x2: 445.249,
    y2: 321.697
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M454.588,347.922 c-3.765,7.908-6.827,17.514-7.419,28.426v37.073"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M467.491,328.181 c-3.502,4.043-8.651,10.81-12.903,19.741"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M471.551,323.888 c0,0-0.779,0.711-2.059,2.073"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M431.05,350.703 c4.382,6.057,8.784,13.986,12.178,24.167"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M422.408,340.773 c2.652,2.516,5.643,5.785,8.642,9.931"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M413.18,333.74 c0,0,2.679,1.373,6.581,4.663"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M431.366,328.827 c4.161,13.096,9.748,32.448,12.354,49.246"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M428.831,321.058 c0.74,2.208,1.602,4.831,2.535,7.768"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M426.234,313.544 c0,0,0.728,2.005,1.898,5.443"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M462.374,358.198 c-5.199,1.971-12.309,7.471-14.776,14.675"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M471.978,356.245 c-2.799,0.164-6.227,0.672-9.604,1.953"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M478.201,356.399 c0,0-0.926-0.132-2.452-0.192"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M461.855,392.504c7.027,3.281,13.881,3.462,15.309,0.403 c1.428-3.058-3.111-8.197-10.138-11.478c-7.027-3.281-13.881-3.461-15.309-0.403C450.29,384.084,454.829,389.223,461.855,392.504 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M462.078,383.605 c-2.396-1.456-5.505-2.987-9.012-3.853c0,0-2.349-1.567-4.835,0.091c-0.95,0.634-0.634,5.385-0.634,5.385v24.709"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M467.11,387.269 c0,0-0.686-0.635-1.908-1.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M411.42,363.693c-7.646-1.295-13.387-5.043-12.824-8.371 c0.564-3.328,7.219-4.975,14.865-3.68c7.646,1.295,13.387,5.043,12.824,8.371C425.722,363.341,419.067,364.988,411.42,363.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M425.736,358.136 c0.916,0.34,1.829,0.737,2.725,1.198c6.319,3.254,10.182,9.882,10.182,16.989v32.663"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M415.492,356.206 c2.887,0.11,6.589,0.572,10.244,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M410.073,356.399 c0,0,0.61-0.087,1.656-0.152"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M419.097,386.067c-6.719,3.873-13.532,4.641-15.217,1.717 c-1.685-2.924,2.395-8.434,9.114-12.307c6.719-3.872,13.532-4.641,15.217-1.717C429.896,376.684,425.816,382.194,419.097,386.067 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M417.465,377.702 c2.295-1.755,5.443-3.757,9.126-5.039c0,0,8.335-1.375,10.235,4.01"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M413.411,381.303 c0,0,0.414-0.456,1.179-1.172"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M435.56,376.991c0,0,9.82-1.901,9.82,4.752 s-6.969,12.038-9.82,19.641c-2.851,7.603-8.236,7.92-11.088,0.317C421.621,394.097,425.739,380.159,435.56,376.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M442.212,377.308c0,0-8.553,3.485-11.087,14.572"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 441.578,
    y1: 391.88,
    x2: 441.578,
    y2: 409.937
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M425.845,445.1c-2.243-6.995-3.553-15.071-3.553-23.113c0-4.982,0.506-9.744,1.421-14.133h40.013 c0.915,4.389,1.421,9.151,1.421,14.133c0,8.042-1.309,16.118-3.553,23.113H425.845z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A7A7A"
    },
    d: "M464.753,414.462c0.115,1.086,0.203,2.188,0.268,3.304H422.42 c0.065-1.115,0.153-2.218,0.268-3.304H464.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A7A7A"
    },
    d: "M422.873,431.347c-0.134-1.095-0.25-2.196-0.338-3.304h42.369 c-0.088,1.108-0.204,2.209-0.338,3.304H422.873z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M459.976,422.17c0,0.919,0.772,1.664,1.724,1.664c0.952,0,1.724-0.745,1.724-1.664 c0-0.919-0.772-1.664-1.724-1.664C460.747,420.506,459.976,421.251,459.976,422.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M451.355,422.17c0,0.919,0.772,1.664,1.724,1.664c0.952,0,1.724-0.745,1.724-1.664 c0-0.919-0.772-1.664-1.724-1.664C452.127,420.506,451.355,421.251,451.355,422.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M442.735,422.17c0,0.919,0.772,1.664,1.724,1.664c0.952,0,1.724-0.745,1.724-1.664 c0-0.919-0.772-1.664-1.724-1.664C443.507,420.506,442.735,421.251,442.735,422.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M434.115,422.17c0,0.919,0.772,1.664,1.724,1.664c0.952,0,1.724-0.745,1.724-1.664 c0-0.919-0.772-1.664-1.724-1.664C434.887,420.506,434.115,421.251,434.115,422.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M425.495,422.17c0,0.919,0.772,1.664,1.724,1.664c0.952,0,1.724-0.745,1.724-1.664 c0-0.919-0.772-1.664-1.724-1.664C426.266,420.506,425.495,421.251,425.495,422.17z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 16.749,
    y1: 445.1,
    x2: 495.99,
    y2: 445.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.306,
    y: 64.87,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 98.846,
    height: 103.043
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.45,
    y: 64.87,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 98.846,
    height: 103.043
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.306,
    y: 175.221,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 98.846,
    height: 103.043
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.45,
    y: 175.221,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 98.846,
    height: 103.043
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.306,
    y: 285.572,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 98.846,
    height: 103.043
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.45,
    y: 285.572,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 98.846,
    height: 103.043
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Poster"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.528,
    y: 81.669,
    transform: "matrix(1 0.0014 -0.0014 1 0.281 -0.2022)",
    style: {
      fill: "#A8A8A8"
    },
    width: 170.211,
    height: 226.948
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M165.757,105.947c0,0-7.791,2.422-11.698,11.664c-3.907,9.242-5.377,16.54-8.305,21.889 c-2.928,5.349-11.689,5.824-12.665,7.282c-0.975,1.459,4.369,7.793,4.369,7.793s5.307,32.13,6.765,34.078 c1.457,1.949,24.335,0.035,24.335,0.035s2.92,0.491-0.009,6.327c-2.929,5.836-2.929,5.836-2.929,5.836l12.165,1.964l31.754-82.693 L165.757,105.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M176.489,88.928c0,0-12.651-2.452-20.452,7.271c-7.801,9.723-13.664,25.288-13.664,25.288 l18.478,11.221l7.312-7.777l-3.908,10.215l17.018,11.219l6.832-12.644l-0.511,16.547c0,0-8.304,20.916-25.354,32.085 c-17.05,11.169-71.077,13.525-95.436,30.525c-4.412,3.079-8.145,5.867-11.313,8.376l-0.036,24.756 c2.158-2.522,4.617-5.003,7.418-7.343c18.029-15.062,35.56-21.85,35.56-21.85s-25.823,19.431-38.992,38.88 c-1.446,2.136-2.769,4.12-4.009,6.001l-0.067,46.797l170.211,0.245l0.325-225.794C215.874,81.804,193.114,80.461,176.489,88.928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38,
      fill: "#FFFFFF"
    },
    d: "M176.489,88.928c0,0-12.651-2.452-20.452,7.271 c-7.801,9.723-13.664,25.288-13.664,25.288l18.478,11.221l7.312-7.777l-3.908,10.215l17.018,11.219l6.832-12.644l-0.511,16.547 c0,0-8.304,20.916-25.354,32.085c-17.05,11.169-71.077,13.525-95.436,30.525c-4.412,3.079-8.145,5.867-11.313,8.376l-0.036,24.756 c2.158-2.522,4.617-5.003,7.418-7.343c18.029-15.062,35.56-21.85,35.56-21.85s-25.823,19.431-38.992,38.88 c-1.446,2.136-2.769,4.12-4.009,6.001l-0.067,46.797l170.211,0.245l0.325-225.794C215.874,81.804,193.114,80.461,176.489,88.928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M153.307,138.084c0,0,1.168,1.159,7.406,3.484s22.229,2.926,22.229,2.926 s-9.365,2.302-10.925,2.589c-1.561,0.287,4.286,2.9,4.286,2.9s-7.022,0.858-15.208-2.627 C152.909,143.872,147.458,137.207,153.307,138.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M141.677,165.307 c0,0,3.181,1.741,5.792-2.307"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 151.124,
    y1: 143.93,
    x2: 155.596,
    y2: 135.019
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M164.836,159.801c-0.591,1.469-4.025,1.469-7.669,0.002c-3.644-1.467-6.119-3.848-5.527-5.316 s4.025-1.469,7.669-0.002C162.952,155.952,165.427,158.333,164.836,159.801z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.093,
    y: 145.999,
    transform: "matrix(0.8947 0.4466 -0.4466 0.8947 83.1759 -55.7673)",
    style: {
      fill: "#263238"
    },
    width: 11.564,
    height: 5.08
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M157.566,146.838c0,0.793-0.643,1.436-1.436,1.436c-0.793,0-1.436-0.643-1.436-1.436 c0-0.793,0.643-1.436,1.436-1.436C156.923,145.402,157.566,146.045,157.566,146.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.818,149.51c0,0.537-0.435,0.972-0.972,0.972s-0.972-0.435-0.972-0.972 c0-0.537,0.435-0.972,0.972-0.972S161.818,148.974,161.818,149.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.051,146.68l18.399,8.378c0,0-4.214-0.821-9.756-2.866 C154.152,150.147,151.051,146.68,151.051,146.68z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M128.173,229.233c0.317,0.254,0.507,0.445,0.506,0.635c0,0.253-0.255,0.507-0.825,0.823 l-2.094,1.138l-0.046,32.015c-0.007,4.818,0.114,8.749,0.3,11.602l-0.001,0.381c-0.001,0.951-0.256,1.14-1.778,1.772 c-0.634,0.253-1.015,0.379-1.268,0.378c-0.381-0.001-0.444-0.318-0.443-0.824l0.008-5.896l-29.163-0.042l-0.008,5.769 c-0.001,0.824-0.065,1.014-1.397,1.583c-0.571,0.253-1.015,0.379-1.268,0.378c-0.444-0.001-0.57-0.381-0.569-1.332l0.001-0.697 c0.132-3.74,0.204-9.446,0.209-13.059l0.046-31.952c0.003-2.346-0.057-4.565-0.181-6.53l4.37,3.366l27.134,0.039l1.842-2.85 L128.173,229.233z M122.567,247.927l0.025-17.751l-29.163-0.042l-0.026,17.751L122.567,247.927z M122.536,269.862l0.03-20.54 l-29.163-0.042l-0.03,20.54L122.536,269.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M200.775,267.248c-2.472-0.194-4.121,0.248-5.645,1.386c-0.19,0.19-0.381,0.253-0.571,0.253 c-1.014-0.001-15.072-11.433-20.56-30.397l-1.331-0.002l-0.04,27.831l7.988,0.012l2.604-3.419l4.052,3.492 c0.38,0.318,0.57,0.635,0.569,0.825c-0.001,0.317-0.318,0.507-0.888,0.506l-14.328-0.021c-0.007,4.501,0.052,8.305,0.174,11.095 l0,0.317c-0.002,1.078-0.319,1.457-1.778,2.279c-0.508,0.316-0.889,0.443-1.142,0.442c-0.317-0.001-0.444-0.318-0.443-1.015 l0.001-0.697c0.195-3.043,0.203-8.749,0.209-12.426l-8.939-0.013c-1.268-0.002-3.107,0.249-4.058,0.628l-1.709-2.284 c1.458,0.128,3.043,0.258,4.438,0.26l10.27,0.015l0.039-27.26c-7.121,14.381-15.505,25.209-27.372,33.56l-0.57-0.824 c11.679-9.556,19.112-20.577,24.709-33.312l-16.039-0.023c-1.331-0.002-3.17,0.249-4.249,0.691l-1.771-2.348 c1.585,0.129,3.17,0.258,4.627,0.26l20.668,0.03l0.008-5.389c0.004-2.599-0.117-6.91-0.241-9.256l4.879,2.162 c0.317,0.127,0.507,0.381,0.506,0.572c0,0.253-0.128,0.443-0.381,0.57l-1.777,1.075l-0.015,10.27l17.434,0.025l2.859-4.18 l4.241,4.317c0.317,0.317,0.443,0.571,0.443,0.761c-0.001,0.317-0.318,0.507-0.952,0.506l-21.301-0.031 c3.6,9.705,12.518,24.299,25.382,27.805L200.775,267.248z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M137.214,181.764c0.013-8.908-7.198-16.139-16.106-16.152c-7.031-0.01-13,4.487-15.218,10.759 c-2.199-6.279-8.156-10.793-15.187-10.803c-8.908-0.013-16.139,7.198-16.152,16.106c-0.008,5.262,2.517,9.924,6.411,12.874 l24.4,23.915l0.455,0.446l0.456-0.445l24.393-23.77C134.626,191.759,137.207,187.07,137.214,181.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M85.456,147.482c0.006-3.854-3.114-6.983-6.969-6.989c-3.042-0.004-5.625,1.941-6.584,4.655 c-0.952-2.716-3.529-4.67-6.571-4.674c-3.854-0.006-6.983,3.114-6.989,6.969c-0.003,2.277,1.089,4.294,2.774,5.57l10.557,10.347 l0.197,0.193l0.197-0.192l10.554-10.285C84.336,151.807,85.452,149.777,85.456,147.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.654,201.944c0.006-3.854-3.114-6.983-6.969-6.989c-3.042-0.004-5.625,1.941-6.584,4.655 c-0.952-2.717-3.529-4.67-6.571-4.674c-3.854-0.006-6.983,3.114-6.989,6.969c-0.003,2.277,1.089,4.294,2.774,5.57l10.557,10.347 l0.197,0.193l0.197-0.192l10.554-10.285C203.534,206.269,204.65,204.24,204.654,201.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M135.279,97.304c0.006-3.854-3.114-6.983-6.968-6.989c-3.042-0.004-5.625,1.942-6.584,4.655 c-0.952-2.716-3.529-4.67-6.571-4.674c-3.854-0.006-6.983,3.114-6.989,6.969c-0.003,2.277,1.089,4.294,2.774,5.57l10.557,10.347 l0.197,0.193l0.197-0.192l10.554-10.285C134.16,101.629,135.276,99.6,135.279,97.304z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 65.901,
    y1: 297.837,
    x2: 214.592,
    y2: 298.051
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 91.289,
    y1: 287.617,
    x2: 189.233,
    y2: 287.758
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.528,
    y: 81.669,
    transform: "matrix(1 0.0014 -0.0014 1 0.281 -0.2022)",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 170.211,
    height: 226.948
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M99.643,136.351H66.283c-3.208,0-5.808-2.6-5.808-5.808V95.959c0-3.208,2.6-5.808,5.808-5.808 h33.361c3.208,0,5.808,2.601,5.808,5.808v34.584C105.452,133.75,102.851,136.351,99.643,136.351z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M77.958,95.01c0.102,0.082,0.163,0.143,0.163,0.204c0,0.081-0.082,0.163-0.265,0.264 l-0.672,0.365l-0.015,10.282c-0.002,1.547,0.037,2.81,0.097,3.726l0,0.122c0,0.305-0.082,0.366-0.571,0.569 c-0.204,0.081-0.326,0.122-0.407,0.121c-0.122,0-0.142-0.102-0.142-0.265l0.003-1.894l-9.366-0.013l-0.003,1.853 c0,0.265-0.021,0.326-0.449,0.508c-0.183,0.081-0.326,0.122-0.407,0.122c-0.143,0-0.183-0.122-0.183-0.428l0-0.224 c0.042-1.201,0.065-3.034,0.067-4.194l0.015-10.262c0.001-0.753-0.018-1.466-0.058-2.097l1.403,1.081l8.714,0.012l0.592-0.915 L77.958,95.01z M76.157,101.013l0.008-5.701L66.8,95.299L66.791,101L76.157,101.013z M76.147,108.058l0.009-6.597l-9.366-0.014 l-0.009,6.597L76.147,108.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M101.275,107.219c-0.794-0.062-1.324,0.08-1.813,0.445c-0.061,0.061-0.122,0.081-0.183,0.081 c-0.326,0-4.84-3.672-6.603-9.762l-0.428-0.001l-0.013,8.938l2.565,0.004l0.836-1.098l1.301,1.122 c0.122,0.102,0.183,0.204,0.183,0.265c0,0.102-0.102,0.163-0.285,0.162l-4.602-0.007c-0.002,1.446,0.017,2.667,0.056,3.563 l0,0.102c-0.001,0.346-0.103,0.468-0.571,0.732c-0.163,0.102-0.285,0.142-0.367,0.142c-0.102,0-0.142-0.102-0.142-0.326l0-0.224 c0.063-0.977,0.065-2.81,0.067-3.991l-2.871-0.004c-0.407,0-0.998,0.08-1.303,0.202l-0.549-0.734 c0.468,0.041,0.977,0.083,1.425,0.083l3.299,0.005l0.013-8.755c-2.287,4.618-4.98,8.096-8.791,10.778l-0.183-0.265 c3.751-3.069,6.138-6.608,7.936-10.698l-5.151-0.007c-0.428-0.001-1.018,0.08-1.365,0.222l-0.569-0.754 c0.509,0.041,1.018,0.083,1.486,0.083l6.638,0.009l0.002-1.731c0.001-0.835-0.038-2.219-0.077-2.973l1.567,0.694 c0.102,0.041,0.163,0.122,0.163,0.184c0,0.081-0.041,0.142-0.122,0.183l-0.571,0.345l-0.005,3.298l5.599,0.008l0.918-1.343 l1.362,1.387c0.102,0.102,0.142,0.183,0.142,0.244c0,0.102-0.102,0.163-0.306,0.162l-6.841-0.01 c1.156,3.117,4.02,7.804,8.152,8.93L101.275,107.219z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.58
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M77.958,117.552c0.102,0.082,0.163,0.143,0.163,0.204c0,0.081-0.082,0.163-0.265,0.264 l-0.672,0.365l-0.015,10.282c-0.002,1.547,0.037,2.81,0.097,3.726l0,0.122c0,0.305-0.082,0.366-0.571,0.569 c-0.204,0.081-0.326,0.122-0.407,0.122c-0.122,0-0.142-0.102-0.142-0.265l0.003-1.893l-9.366-0.014l-0.003,1.853 c0,0.265-0.021,0.326-0.449,0.508c-0.183,0.081-0.326,0.122-0.407,0.122c-0.143,0-0.183-0.122-0.183-0.428l0-0.224 c0.042-1.201,0.065-3.034,0.067-4.194l0.015-10.262c0.001-0.753-0.018-1.466-0.058-2.097l1.403,1.081l8.714,0.013l0.592-0.915 L77.958,117.552z M76.157,123.556l0.008-5.701l-9.366-0.013l-0.008,5.701L76.157,123.556z M76.147,130.601l0.009-6.597 l-9.366-0.013l-0.009,6.597L76.147,130.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M101.275,129.761c-0.794-0.062-1.324,0.08-1.813,0.445c-0.061,0.061-0.122,0.081-0.183,0.081 c-0.326-0.001-4.84-3.672-6.603-9.762l-0.428-0.001l-0.013,8.938l2.565,0.004l0.836-1.098l1.301,1.122 c0.122,0.102,0.183,0.204,0.183,0.265c0,0.102-0.102,0.163-0.285,0.162l-4.602-0.007c-0.002,1.446,0.017,2.667,0.056,3.563 l0,0.102c-0.001,0.346-0.103,0.468-0.571,0.732c-0.163,0.102-0.285,0.142-0.367,0.142c-0.102,0-0.142-0.102-0.142-0.326l0-0.224 c0.063-0.977,0.065-2.81,0.067-3.991l-2.871-0.004c-0.407-0.001-0.998,0.08-1.303,0.202l-0.549-0.734 c0.468,0.041,0.977,0.083,1.425,0.083l3.299,0.005l0.013-8.755c-2.287,4.618-4.98,8.096-8.791,10.778l-0.183-0.265 c3.751-3.069,6.138-6.608,7.936-10.698l-5.151-0.007c-0.428-0.001-1.018,0.08-1.365,0.222l-0.569-0.754 c0.509,0.041,1.018,0.083,1.486,0.084l6.638,0.01l0.002-1.731c0.001-0.835-0.038-2.219-0.077-2.973l1.567,0.694 c0.102,0.041,0.163,0.122,0.163,0.184c0,0.081-0.041,0.142-0.122,0.183l-0.571,0.345l-0.005,3.298l5.599,0.008l0.918-1.342 l1.362,1.387c0.102,0.102,0.142,0.183,0.142,0.244c0,0.102-0.102,0.163-0.306,0.162l-6.841-0.01 c1.156,3.117,4.02,7.804,8.152,8.93L101.275,129.761z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.926 -0.3774 0.3774 0.926 -38.5215 98.7776)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 232.758,
    cy: 147.672,
    rx: 28.102,
    ry: 28.102
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 234.545,
    cy: 150.271,
    rx: 15.919,
    ry: 16.082
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6482 -0.7614 0.7614 0.6482 -20.0724 351.3085)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 370.183,
    cy: 197.378,
    rx: 28.102,
    ry: 28.102
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M352.44,195.045 c-2.425,8.544,2.466,17.417,10.924,19.817c8.458,2.4,17.28-2.58,19.705-11.124c2.425-8.544-2.466-17.417-10.924-19.817 C363.687,181.52,354.865,186.501,352.44,195.045z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M201.407,238.476 c0,0-0.975,9.097,4.548,13.645c5.523,4.548,33.463,20.467,42.234,28.589c8.772,8.122,17.219,16.244,17.219,16.244 s52.767-3.031,64.232-5.739c11.465-2.708,19.587-8.881,24.785-15.054s6.173-17.543,3.899-25.341 c-2.274-7.797-8.447-24.041-18.518-45.808s-39.311-43.859-68.55-37.361c-29.239,6.498-59.453,39.635-62.052,46.133 C206.605,220.283,201.407,238.476,201.407,238.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M257.287,281.035 c0,0-26.965-17.543-37.036-16.569c-10.071,0.975-44.833,68.225-44.833,68.225s-5.848,10.721-1.624,21.767 c4.223,11.046,25.99,39.311,25.99,39.311l-7.797,51.331h161.79l-6.822-69.849c0,0,18.193-4.224,18.193-6.173 c0-1.949-19.168-70.824-25.991-78.621c-6.822-7.797-15.594-10.071-25.99-10.721c-10.396-0.65-28.59,0.325-33.138,0.325 C275.48,280.061,257.287,281.035,257.287,281.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M239.743,276.136 c0,0-2.589,6.472,3.883,18.64c6.472,12.168,17.087,17.605,17.087,17.605s20.97-3.366,31.326-10.356 c10.356-6.99,23.818-23.041,23.818-23.041l-16.051-22.006l-65.241-4.142L239.743,276.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M251.393,255.683 c0,0,0.518,35.209,4.401,44.789c3.883,9.579,4.919,11.909,4.919,11.909s22.265-16.828,28.737-25.372 c6.472-8.543,12.945-32.362,12.945-32.362l-53.332-8.285L251.393,255.683z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "267.251,270.496  294.961,276.548 297.509,258.393  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M234.489,259.065 c-7.194-0.49-19.485-8.443-20.459-15.913c-0.974-7.469,4.222-14.614,4.222-14.614s-0.974,3.897,1.624,7.145 c2.598,3.247,12.34,1.299,12.99-3.897s-3.897-20.135-6.82-28.253c-2.923-8.119,1.624-14.939,1.624-14.939 s12.665-17.536,46.115-26.63c33.449-9.093,56.507-0.974,63.976,20.459c7.469,21.434,14.614,48.388,12.016,56.182 c-2.598,7.794-16.238,19.485-20.784,27.279c-4.547,7.794-1.624,12.016,2.598,12.665c4.222,0.65,8.119-1.948,8.119-1.948 s-1.624,10.717-10.067,14.614c-8.444,3.897-24.032-0.65-26.954-3.897c-2.923-3.247-6.17-11.366-6.82-15.588 c-0.65-4.222,0.325-11.042,0.325-11.042l-45.14-11.366C251.051,249.323,248.778,260.039,234.489,259.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M242.219,183.005 c0,0,41.101-13.805,57.416-10.667c16.315,3.137,40.286,53.529,42.042,69.652c0.408,3.743,0.939,6.571,0.939,6.571l5.091-7.246 c0,0-24.856-68.664-32.699-74.311c-7.844-5.647-27.61-5.334-42.356-1.569C257.906,169.2,242.219,183.005,242.219,183.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M325.456,219.724 c1.137-2.141,1.587-3.851,1.587-3.851"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M313.403,229.838 c0,0,2.273-0.65,7.145-4.222c1.014-0.743,1.887-1.599,2.634-2.488"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M308.207,197.363 c0,0,4.871-3.247,6.495-11.366"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M288.145,175.108 c0.755-1.008,1.595-2.042,2.526-3.076"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M282.552,185.022 c0,0,0.904-2.583,3.038-6.119"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M256.208,184.79 c1.206-1.148,2.515-2.264,3.936-3.34"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M243.257,226.265 c0,0-4.516-21.323,9.825-38.173"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M236.001,218.389 c0.196,1.204,0.447,2.424,0.761,3.655"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M238.71,193.141 c0,0-4.183,9.761-3.113,22.009"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M329.485,248.383 c-6.526,10.179-8.937,13.93-8.937,13.93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M334.187,223.343 c0,0,5.521,9.093-2.598,21.758"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M332.563,227.889 c0,0,0.325,5.196-7.794,10.717c-8.119,5.521-11.042,8.444-11.042,8.444"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M228.366,243.83 c0,0,7.765-12.669,10.83-14.713c3.065-2.043,5.109-1.022,5.722,2.043c0.613,3.065,1.431,6.13,1.431,6.13 s-13.487,6.743-15.122,7.561C229.592,245.669,228.775,246.282,228.366,243.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M242.396,234.882 c0,0-17.654,8.126-15.972,12.89c1.681,4.764,12.049,30.543,12.049,30.543l-11.209,22.417l9.807,11.769 c0,0,14.851-24.939,16.813-29.423s3.363-11.769,2.242-17.093c-1.121-5.324-9.527-28.021-10.368-30.263 C244.918,233.481,242.396,234.882,242.396,234.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M246.961,244.238 c0,0-0.204,5.313-0.817,7.356c-0.613,2.044-5.109,3.065-6.13,2.861c-1.022-0.204-2.452-4.904-2.452-4.904 s2.043-1.635,2.656-1.839"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M245.122,254.047 c0,0,7.969,10.013,8.174,15.53c0.204,5.517-1.43,9.4-1.43,9.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M315.008,248.121 c0,0,2.657-2.657,4.087-0.817c1.43,1.839,6.335,13.282,6.539,16.143c0.204,2.861-0.409,5.926-0.409,5.926L315.008,248.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M285.378,315.759 c0,0-8.378-38.008-6.743-39.234c1.635-1.226,22.273-11.239,22.273-11.239s-3.882-2.248-3.27-3.27 c0.613-1.022,16.143-13.691,17.369-13.895c1.226-0.204,6.13,10.217,7.561,13.487c1.43,3.269,3.883,8.174,1.43,9.4 c-2.452,1.226-17.369,10.217-21.252,11.852c-3.883,1.635-8.787,3.474-8.787,3.474l12.465,24.317L285.378,315.759z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "300.908,265.286 303.36,264.673  303.156,262.22 305.404,269.372  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M307.447,254.047 c0,0,6.948,18.8,6.743,21.456"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M312.147,250.164 c0,0,7.561,16.143,7.561,22.478"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M282.552,185.022 c0,0-15.588-0.974-24.681,11.366c-9.093,12.341-11.042,18.836-11.691,24.681c-0.65,5.846-0.325,8.768-0.325,8.768l-2.598-3.572 c0,0-0.325,4.547,1.624,14.289c1.949,9.742,8.768,26.305,13.64,29.228c4.871,2.923,16.887,0.325,22.408-1.299 c5.521-1.624,22.733-8.768,25.006-12.341c2.273-3.572,5.196-8.443,5.196-8.443s-1.299-15.588-1.299-16.562 c0-0.974-2.923,0.649-2.923,0.649s-0.974-10.067-0.974-18.186c0-8.119,0-13.964,0-13.964s-8.119,8.119-13.64,11.366 c-5.521,3.247-12.665,8.443-13.315,9.743c-0.65,1.299,1.949-24.681,1.949-27.604 C280.928,190.218,282.552,185.022,282.552,185.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M258.398,211.155 c0,0,9.364-2.943,11.813,4.718"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M277.662,206.339 c0,0-2.14-9.097-12.04-7.224"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M293.715,216.506 c0,0,8.829-1.07,11.505,8.294"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M291.04,226.406 c0,0,8.829-1.07,9.632,8.294"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M270.438,229.349 c0,0-1.07,3.211,2.408,5.083c3.478,1.873,6.689-0.535,7.491-1.338"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M260.271,238.713 c0,0,3.211,12.575,19.799,10.167"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M260.713,312.381 c0,0-7.249,21.229-6.213,22.783c1.036,1.553,5.437,2.071,6.731,0.777C262.525,334.646,260.713,312.381,260.713,312.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M212.453,301.828 c0,0-8.447-0.65-10.721,4.223c-2.274,4.873-21.767,29.564-21.767,29.564s-7.797-1.949-10.071,2.599 c-2.274,4.548-5.198,7.472-4.548,9.097c0.65,1.624,1.949,29.564,5.523,35.412c3.574,5.848,24.691,19.493,28.914,21.117 c4.224,1.624,17.219-9.746,20.467-14.62c3.249-4.873,24.691-46.133,22.092-52.956c-2.599-6.822-5.198-5.523-5.198-5.523 L212.453,301.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M318.039,315.797 c0,0,2.924-1.949,5.848,0.325c2.924,2.274,19.818,33.463,19.818,33.463s3.249,0,5.848,1.949 c2.599,1.949,16.569,17.544,17.543,24.691c0.975,7.147-1.949,14.295-3.898,16.244c-1.949,1.949-16.244,17.219-20.792,19.818 c-4.548,2.599-28.59-4.873-32.163-6.498s-9.422-7.472-9.746-11.371c-0.325-3.898-17.219-48.732-17.219-52.306 s2.924-4.548,2.924-4.548L318.039,315.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M257.612,338.864 c0,0-0.325,79.271,5.523,99.089"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M269.66,338.085 c4.208,15.13,10.707,37.114,15.567,47.237"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M265.409,322.295 c0,0,0.957,3.722,2.505,9.432"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M279.891,404.85 c1.421,2.483,2.98,4.879,4.685,7.112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M266.708,365.829 c0,0,2.591,17.34,10.271,33.443"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M244.925,374.389 c-4.152,10.002-10.646,25.319-14.603,33.025"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M248.84,364.854 c0,0-0.657,1.624-1.742,4.27"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M204.331,207.612 c0,0-4.223,33.138-2.924,30.864c1.3-2.274,23.391-49.057,51.006-61.078c27.615-12.021,51.981-12.021,57.179-8.447 s34.437,66.276,38.986,80.57c4.548,14.295,5.523,19.818,4.873,23.391c-0.65,3.574-2.924,7.797-2.924,7.797 s14.62-7.797,17.219-14.295c2.599-6.498-7.147-20.792-8.447-25.99c-1.299-5.198-2.599-40.935-12.345-63.027 c-9.746-22.092-22.092-36.712-48.732-35.737c-26.64,0.975-47.108,4.873-62.052,25.666S206.93,201.764,204.331,207.612z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M299.553,146.816 c0,1.686-2.477,3.053-5.534,3.053c-3.056,0-5.533-1.367-5.533-3.053c0-1.686,2.477-3.053,5.533-3.053 C297.076,143.764,299.553,145.13,299.553,146.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M325.134,155.505 c-0.852,1.455,0.594,3.886,3.231,5.431c2.637,1.545,5.465,1.618,6.318,0.163c0.852-1.455-0.594-3.886-3.231-5.431 C328.815,154.123,325.986,154.05,325.134,155.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M323.444,151.7 c-2.344,6.171-8.875,9.413-14.588,7.243c-5.712-2.17-8.443-8.932-6.099-15.102s8.875-9.413,14.588-7.243 C323.057,138.768,325.788,145.529,323.444,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.316,156.548c0,2.424-5.467,4.389-12.212,4.389c-6.744,0-12.212-1.965-12.212-4.389 c0-2.424,5.467-4.389,12.212-4.389C294.849,152.159,300.316,154.124,300.316,156.548z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M334.557,178.346c-1.721,1.706-6.966-0.794-11.713-5.585c-4.747-4.79-7.201-10.057-5.479-11.763 c1.721-1.706,6.966,0.794,11.713,5.584C333.826,171.373,336.279,176.639,334.557,178.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "280.353,313.848  286.201,337.564 318.039,315.797 309.268,299.228  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "284.215,329.511  316.032,312.005 312.756,305.818 282.481,322.476  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "223.174,288.183  247.54,310.275 237.144,330.742 212.453,301.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "214.226,299.571  240.501,324.133 243.801,317.636 218.566,294.047  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.305,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.541,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.777,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.013,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.249,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.486,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.722,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.958,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.194,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.43,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.666,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.903,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.139,
    y: 439.983,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 8.989,
    height: 1.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.226,
    y: 440.951,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 155.87,
    height: 4.244
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M216.439,404.411H21.728 c-3.812,0-6.902-3.09-6.902-6.902V266.594c0-3.812,3.09-6.902,6.902-6.902h194.711c3.812,0,6.902,3.09,6.902,6.902V397.51 C223.34,401.321,220.25,404.411,216.439,404.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1A1A1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M211.634,404.411H16.923 c-3.812,0-6.902-3.09-6.902-6.902V266.594c0-3.812,3.09-6.902,6.902-6.902h194.711c3.812,0,6.902,3.09,6.902,6.902V397.51 C218.536,401.321,215.446,404.411,211.634,404.411z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M126.485,442.491 c-4.885,0-5.653-3.175-5.653-3.175l2.77-108.741H90.937L74.168,439.316c-0.84,6.97,4.598,5.805,4.598,5.805h83.791v-2.63 C162.557,442.491,131.37,442.491,126.485,442.491z M112.557,385.926c-0.486,6.935-5.579,12.227-11.376,11.82 c-5.796-0.407-10.101-6.358-9.614-13.293c0.486-6.935,5.579-12.227,11.376-11.82C108.739,373.04,113.044,378.992,112.557,385.926z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Toy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M312.585,408.444 c0,0-24.958-7.818-24.657-0.301c0.301,7.517,13.531,12.629,13.531,12.629s-9.622,11.126-8.72,15.035 c0.902,3.909,20.748,9.923,35.783,9.622s24.657-5.413,25.258-9.923c0.601-4.51-2.406-14.734-2.406-14.734 s6.014-9.923,6.014-13.832s-7.517-2.706-9.923-1.203C345.059,407.241,323.71,413.255,312.585,408.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M303.158,405.238 c0,0-8.392,12.406-6.568,14.595c1.824,2.189,4.868,0.939,4.868,0.939s-7.423,8.548-7.423,9.642c0,1.095,15.396,9.24,34.447,8.6 c20.089-0.675,24.299-6.776,25.394-8.965c1.095-2.189-0.73-12.771-0.73-12.771l2.189-4.014c0,0-0.365-4.014-3.284-6.203 s-6.933-2.919-6.933-2.919L303.158,405.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M311.078,411.51 c0,0,2.468,7.899,10.12,13.576c7.652,5.677,14.564,4.69,19.994-0.494c5.431-5.184,7.405-15.551,7.405-15.551L311.078,411.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M349.361,406.203 c0,0,5.867,3.562,5.238,8.591l2.095-4.4c0,0-2.934-6.496-6.915-7.124L349.361,406.203z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 352.202,
    cy: 381.678,
    r: 9.923
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 322.132,
    cy: 374.587,
    r: 5.874
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 328.943,
    cy: 395.985,
    rx: 24.343,
    ry: 23.796
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 307.53,
    cy: 386.123,
    r: 12.465
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M305.987,404.736 c0,0-5.238-1.676-6.915-0.419c-1.676,1.257-6.077,11.315-6.286,12.782c-0.21,1.467,3.805,2.735,3.805,2.735L305.987,404.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M295.51,427.995 c0,0,0.196,0.231-1.474,2.42c-1.669,2.19-1.46,2.609-0.412,3.656s12.153,7.124,27.659,7.753 c15.506,0.629,25.354-2.934,28.288-3.981c2.934-1.048,4.4-2.724,4.61-4.4c0.21-1.676-0.303-3.393-0.303-3.393 S327.988,444.129,295.51,427.995z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mug"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M381.011,400.864 c0,0,7.169-3.883,12.248-0.896s5.975,19.417,2.987,25.691c-2.987,6.273-12.547,4.78-12.547,4.78v-6.871 c0,0,5.377,1.195,7.767-5.078c2.39-6.273-1.195-11.053-3.286-10.754c-2.091,0.299-5.975,2.091-5.975,2.091L381.011,400.864z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.482,
    y: 392.608,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 41.604,
    height: 52.587
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M348.735,388.163 c0-4.254,4-4.254,4-8.508c0-4.255-4-4.255-4-8.511c0-4.254,4-4.254,4-8.508c0-4.257-4-4.257-4-8.514c0-4.257,4-4.257,4-8.514"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M363.629,388.163 c0-4.254,4-4.254,4-8.508c0-4.255-4-4.255-4-8.511c0-4.254,4-4.254,4-8.508c0-4.257-4-4.257-4-8.514c0-4.257,4-4.257,4-8.514"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M378.523,388.163 c0-4.254,4-4.254,4-8.508c0-4.255-4-4.255-4-8.511c0-4.254,4-4.254,4-8.508c0-4.257-4-4.257-4-8.514c0-4.257,4-4.257,4-8.514"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingOne);
export default __webpack_public_path__ + "static/media/landingOne.128ccd3d514e271f29c4bd40629a27d8.svg";
export { ForwardRef as ReactComponent };